import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
} from "@mui/material";
import ActionButton from "./ActionButton";

const DeletePlaybookModal = ({ open, onClose, onConfirm, playbook }) => {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle>Delete Playbook</DialogTitle>

      <DialogContent>
        <Typography variant="body2">
          Are you sure you want to delete playbook{" "}
          <strong>"{playbook?.name}"</strong>?
        </Typography>

        <Typography
          variant="caption"
          color="text.secondary"
          sx={{ display: "block", mt: 1.5 }}
        >
          This will permanently remove all associated items and transitions.
        </Typography>
      </DialogContent>

      <DialogActions>
        <ActionButton onClick={onClose} tone="ghost">
          Cancel
        </ActionButton>

        <ActionButton onClick={onConfirm} tone="danger">
          Delete
        </ActionButton>
      </DialogActions>
    </Dialog>
  );
};

export default DeletePlaybookModal;